import { combineReducers } from "redux";
import LoginReducer from "./LoginReducer";
import AddClientReducer from "./AddClientReducer";
import ClientListReducer from "./ProjectListReducer"
import TicketReducer from "../Screens/ticketSystem/ticketReducer";
import HsCodeListReducer from "./HSCodeReducer";
import CompanyListReducer from "./CompanyReducer";
import ItemListReducer from "./ItemReducer";
import BuyerReducer from "./BuyerReducer";
import InvoicesListReducer from "./InvoicesReducer";
import PosInvoiceReducer from "./PosInvoiceReducer";
import HeaderReducer from "./HeaderReducer";
import FBRSnroTestingReducer from "./FBRSnroTestingReducer";
import DashboardReducer from "./DashboardReducer";
import UserReducer from "./UserReducer";
import AdminDashboardReducer from "./AdminDashboardReducer";
import LedgerReportsReducer from "./LedgerReportsReducer";
import ReceivingReducer from "./ReceivingReducer";
import StockReducer from "./StockReducer";
import AtlReducer from "./AtlReducer";
import ProgramSettingsReducer from "./ProgramSettingsReducer";


const rootReducer = combineReducers({
  LoginReducer: LoginReducer,
  AddClientReducer: AddClientReducer,
  ClientListReducer: ClientListReducer,
  TicketReducer: TicketReducer,
  HsCodeListReducer: HsCodeListReducer,
  CompanyListReducer: CompanyListReducer,
  ItemListReducer: ItemListReducer,
  BuyerReducer: BuyerReducer,
  InvoicesListReducer: InvoicesListReducer,
  PosInvoiceReducer: PosInvoiceReducer,
  HeaderReducer: HeaderReducer,
  FBRSnroTestingReducer: FBRSnroTestingReducer,
  DashboardReducer: DashboardReducer,
  UserReducer: UserReducer,
  AdminDashboardReducer: AdminDashboardReducer,
  LedgerReportsReducer: LedgerReportsReducer,
  ReceivingReducer: ReceivingReducer,
  StockReducer: StockReducer,
  AtlReducer: AtlReducer,
  ProgramSettingsReducer: ProgramSettingsReducer,
});

export default rootReducer;
